import * as Actions from '../../../redux/actions'
import Rating from '@material-ui/lab/Rating';
import React from 'react';
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { Image } from 'react-bootstrap'
import { MuvInstructionsPopover } from './MuvInstructionsPopover';

// Currency symbol map
const currencySymbols = {
    USD: "$",
    CAD: "CA$",
    EUR: "€",
    GBP: "£",
    AUD: "A$",
    // Extend if needed
};

export const ExpediaBundleItems = ({ cartItem, is_mobile }) => {
    const expediaCost = Object.values(cartItem?.room_json?.occupancy_pricing || {})?.[0]?.nightly?.[0] || [];




    const checkIn = cartItem?.check_in;
    const checkOut = cartItem?.check_out;
    const rooms = parseInt(cartItem?.check_in_json?.rooms || 1);
    const roomInfo = cartItem?.check_in_json?.muvHotel?.roomInfo;
    const checkInfo = cartItem?.check_in_json?.muvHotel?.checkInfo;
    const nights = moment(checkOut).diff(moment(checkIn), 'days');
    const roomName = roomInfo?.name || cartItem?.check_in_json?.muvHotel?.room_name;

    const totals = Object.values(cartItem?.room_json?.occupancy_pricing || {})?.[0]?.totals;
    const propertyFees = Number(totals?.property_fees?.request_currency?.value ?? 0)
    const baseRate = Number(totals?.exclusive?.request_currency?.value ?? 0);
    // const nightPrice = baseRate / (rooms * nights);
    const nightPrice = baseRate / (nights);


    const totalCost = Number(totals?.inclusive?.request_currency?.value ?? 0);
    const taxesAndFees = totalCost - baseRate;
    let currencyCode = cartItem?.currency || "USD";

    const currencySymbol = "$";
    const roomCost = baseRate * rooms;
    const taxesAndFeesTotal = taxesAndFees * rooms;
    const totalCostTotal = totalCost * rooms;
    const propertyFeesTotal = propertyFees * rooms;

    const allInTotal = totalCostTotal + propertyFeesTotal;

    return (
        <React.Fragment>
            <table style={{ border: "1px solid #E8E8E8", marginBottom: 15, width: "100%" }}>
                <tbody>

                    <tr><td colSpan="2"></td></tr>

                    <tr>
                        <td colSpan="2">
                            <div style={{ paddingLeft: "2rem", font: "18px/22px Futura Hv BT", color: "#000000", marginBottom: "5px", marginTop: 15 }}>
                                {cartItem?.hotel_name}
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td colSpan="2">
                            <div style={{
                                paddingLeft: "2rem",
                                font: is_mobile ? "12px/18px Futura Hv BT" : "14px/16px Futura Hv BT",
                                color: "#707070",
                                width: "99%",
                                marginBottom: "10px"
                            }}>
                                {roomName}
                            </div>
                        </td>
                    </tr>

                    <tr style={{ font: is_mobile ? "14px/18px Futura Lt BT" : "14px/18px Futura Lt BT", color: "#707070" }}>
                        <td><div style={{ paddingLeft: "2rem" }}>Check-in:
                            <div style={{ marginLeft: -10, display: "inline-block" }}>
                                <MuvInstructionsPopover checkInfo={checkInfo} />
                            </div>
                        </div></td>
                        <td>
                            <div style={{
                                font: is_mobile ? "14px/18px Futura Hv BT" : "14px/18px Futura Hv BT",
                                paddingRight: "2rem",
                                textAlign: "right",
                                color: "#000000",
                                whiteSpace: "nowrap"
                            }}>
                                {moment(checkIn).format('MMMM Do, yyyy')}
                            </div>
                        </td>
                    </tr>

                    <tr style={{ font: is_mobile ? "14px/18px Futura Lt BT" : "14px/18px Futura Lt BT", color: "#707070" }}>
                        <td><div style={{ paddingLeft: "2rem", paddingTop: 5, paddingBottom: 12 }}>Check-out:</div></td>
                        <td>
                            <div style={{
                                font: is_mobile ? "14px/18px Futura Hv BT" : "14px/18px Futura Hv BT",
                                paddingRight: "2rem",
                                paddingTop: 5,
                                paddingBottom: 12,
                                textAlign: "right",
                                color: "#000000",
                                whiteSpace: "nowrap"
                            }}>
                                {moment(checkOut).format('MMMM Do, yyyy')}
                            </div>
                        </td>
                    </tr>

                    <tr style={{
                        font: is_mobile ? "14px/16px Futura Md BT" : "14px/16px Futura Md BT",
                        color: "#000000",
                        backgroundColor: "#F5F7F6"
                    }}>
                        <td><div style={{ paddingLeft: "2rem", paddingTop: 10, paddingBottom: 10 }}>Room price:</div></td>
                        <td>
                            <div style={{
                                paddingRight: "2rem",
                                paddingTop: 10,
                                paddingBottom: 10,
                                textAlign: "right",
                                color: "#000000"
                            }}>
                                {currencySymbol}{nightPrice.toFixed(2)}/night
                            </div>
                        </td>
                    </tr>

                    <tr style={{ font: is_mobile ? "14px/16px Futura Lt BT" : "14px/16px Futura Lt BT", color: "#707070" }}>
                        <td>
                            <div style={{ paddingBottom: 10, paddingLeft: "2rem", paddingTop: 10 }}>
                                {rooms} room(s) x {nights} night(s):
                            </div>
                        </td>
                        <td>
                            <div style={{
                                paddingBottom: 10,
                                paddingRight: "2rem",
                                paddingTop: 10,
                                textAlign: "right",
                                color: "#000000"
                            }}>
                                {currencySymbol}{roomCost.toFixed(2)}
                            </div>
                        </td>
                    </tr>

                    <tr style={{ font: is_mobile ? "14px/16px Futura Md BT" : "14px/16px Futura Lt BT", color: "#707070" }}>
                        <td><div style={{ paddingLeft: "2rem", paddingTop: 10, paddingBottom: 10 }}>Taxes and fees:</div></td>
                        <td>
                            <div style={{
                                paddingRight: "2rem",
                                paddingTop: 10,
                                paddingBottom: 10,
                                textAlign: "right",
                                color: "#000000"
                            }}>
                                {currencySymbol}{taxesAndFeesTotal.toFixed(2)}
                            </div>
                        </td>
                    </tr>

                    <tr style={{
                        font: is_mobile ? "14px/16px Futura Md BT" : "14px/16px Futura Md BT",
                        color: "#000000",
                        backgroundColor: "#F5F7F6"
                    }}>
                        <td>
                            <div style={{ paddingLeft: "2rem", paddingTop: 10, paddingBottom: 10 }}>
                                TOTAL<span style={{ font: "16px/16px Futura Lt BT" }}> (Pay now):</span>
                            </div>
                        </td>
                        <td>
                            <div style={{
                                paddingRight: "2rem",
                                paddingTop: 10,
                                paddingBottom: 10,
                                textAlign: "right",
                                color: "#000000"
                            }}>
                                <span style={{ font: "13px/16px Futura Md BT" }}>
                                    {currencyCode}{currencySymbol}{totalCostTotal.toFixed(2)}
                                </span>
                            </div>
                        </td>
                    </tr>

                    {propertyFees ? <tr style={{ font: is_mobile ? "14px/16px Futura Md BT" : "14px/16px Futura Lt BT", color: "#707070" }}>
                        <td><div style={{ paddingLeft: "2rem", paddingTop: 10, paddingBottom: 10 }}>Property Fees (due at the property):
                            <div style={{ marginLeft: -10, display: "inline-block" }}>
                                <MuvInstructionsPopover html={checkInfo?.fees?.mandatory}
                                    htmlTitle="Property Fees"
                                />
                            </div>
                        </div></td>
                        <td>
                            <div style={{
                                paddingRight: "2rem",
                                paddingTop: 10,
                                paddingBottom: 10,
                                textAlign: "right",
                                color: "#000000"
                            }}>
                                {currencySymbol}{propertyFeesTotal.toFixed(2)}
                            </div>
                        </td>
                    </tr> : ""}
                    <tr style={{
                        font: is_mobile ? "14px/18px Futura Hv BT" : "14px/24px Futura Hv BT",
                        color: "white",
                        backgroundColor: "var(--mainDark)"
                    }}>
                        <td>
                            <div style={{ paddingLeft: "2rem", paddingTop: 10, paddingBottom: 10, color: "white" }}>
                                TOTAL STAY COST<span style={{ font: "16px/16px Futura Lt BT", color: "white" }}>:</span>
                            </div>
                        </td>
                        <td>
                            <div style={{
                                paddingRight: "2rem",
                                textAlign: "right",
                                color: "white"
                            }}>
                                {currencyCode}{currencySymbol}{allInTotal.toFixed(2)}
                            </div>
                        </td>
                    </tr>

                </tbody>
            </table>
        </React.Fragment>
    );
};
